import { FoxentryApiResponse } from './FoxentryApiTypes';

const CZECH_COUNTRY_CODE = 'CZ';

/**
 * Sorts a list of companies from Foxentry API response to show Czech companies first
 */
const sortCompaniesWithCzechFirst = (
  companyListResponse: FoxentryApiResponse,
): FoxentryApiResponse => {
  const companies = [...companyListResponse.response.results];

  const sorted = companies.sort((a, b) => {
    const aIsCzech = a.data.country === CZECH_COUNTRY_CODE;
    const bIsCzech = b.data.country === CZECH_COUNTRY_CODE;
    return Number(bIsCzech) - Number(aIsCzech);
  });

  return {
    ...companyListResponse,
    response: {
      ...companyListResponse.response,
      results: sorted,
    },
  };
};

export { sortCompaniesWithCzechFirst };
